/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { AlarmClock, Dot, EllipsisVertical, User, X } from "lucide-react";
// import AddNewBookingForm from "./AddNewBookingForm";
import { updateBookingTable, updateLiveBookingTable } from "@/api/table-floor/tableFloor";
import { toast } from "react-hot-toast";
import SwapTableModal from "./SwapTableModal";
import { getDuration, isCurrentBooking } from "@/lib/bookingUtils";
import { useDispatch, useSelector } from "react-redux";
import { openAddNewBookingTableModal, fetchAndReplaceBooking, closeAddNewBookingTableModal, fetchAllTables } from "@/redux/slice/table-slice/table-slice";
import AddNewBookingForm from "./AddNewBookingForm";
import { setSelectedCustomer } from "@/redux/slice/take-order-slice/selected-customer-slice";
import { setBookingToRedux } from "@/redux/slice/take-order-slice/booking-slice";
import { useNavigate } from "react-router-dom";
import { setIsLoading, setOrderData, updateOrderType } from "@/redux/slice/take-order-slice/order-slice";
import { getSingleOrderApi } from "@/api/take-order/take-order";
import { resetSelectedLiveTable } from "@/redux/slice/table-slice/live-table-slice";
import hasPermission from "@/hooks/hasPermission";
import { Button } from "@/components/ui/button";

const LiveBookingDetails = ({ isOpen, itemsDialog, tableType, setOrderDetailsId, setQuickTable }) => {
  const { selectedRoom, selectedFloor, table_merges } = useSelector((state) => state.table.table);
  const isMerged = itemsDialog?.table_size?.isMerged || table_merges?.some((merge) =>
    merge.tables?.some((table) => table.id === itemsDialog?.id)
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isAddNewBookingFormModalOpen, setIsAddNewBookingFormModalOpen] = useState(false);
  const closeAddNewBookingForm = () => {
    setIsAddNewBookingFormModalOpen(false);
  };
  const [formType, setFormType] = useState("create");

  const statuses = [
    { label: "Free", value: "free" },
    { label: "Reserved", value: "reserved" },
    // { label: "Waiting", value: "waiting" },
    { label: "Occupied", value: "occupied" },
    { label: "Checked In", value: "checked_in" }
  ];


  const [bookingStatuses, setBookingStatuses] = useState({});
  const [pendingStatusChange, setPendingStatusChange] = useState(null);

  const executeLiveChangeStatus = async (tableId, booking_id, value) => {
    const previousStatus =
      bookingStatuses[booking_id] ||
      itemsDialog.bookings.find(b => b.id === booking_id)?.table_status ||
      itemsDialog.bookings.find(b => b.id === booking_id)?.status;

    setBookingStatuses((prev) => ({
      ...prev,
      [booking_id]: value,
    }));
    try {
      let res;
      res = await updateLiveBookingTable(tableId, {booking_id: booking_id, "status": value});
      if (res.status === "success") {
        // dispatch(fetchAllTables(selectedRoom?.id));
        toast.success("Booking status updated successfully!");
      } else {
        toast.error(res.message || "Something went wrong!");
        setBookingStatuses((prev) => ({
          ...prev,
          [booking_id]: previousStatus,
        }));
      }
    } catch (err) {
      toast.error(err?.message || "Failed to process Floor Card");
      setBookingStatuses((prev) => ({
        ...prev,
        [booking_id]: previousStatus,
      }));
    }
  };

  const getConfirmationMessage = (statusValue, hasOrder) => {
    if (statusValue === "occupied" && hasOrder) {
      return "If you make this table occupied for this booking then kitchen will start cooking so do you wanted to occupy this table?";
    }
    switch (statusValue) {
      case "free":
        return "Do you want to make this table free for this booking?";
      case "checked_in":
        return "Do you want to make this booking status Checked In?";
      case "reserved":
        return "Do you want to make this booking status Reserved?";
      case "occupied":
        return "If you make this table occupied for this booking then kitchen will start cooking so do you wanted to occupy this table?";
      default:
        return `Do you want to change this booking status to ${statusValue}?`;
    }
  };

  const handleLiveChangeStatus = async (tableId, booking_id, value) => {
    setPendingStatusChange({ tableId, bookingId: booking_id, value });
  };

  const handleConfirmStatusChange = () => {
    if (pendingStatusChange) {
      const { tableId, bookingId, value } = pendingStatusChange;
      executeLiveChangeStatus(tableId, bookingId, value);
      setPendingStatusChange(null);
    }
  };

  const handleCancelStatusChange = () => {
    setPendingStatusChange(null);
  };

  const groupedBookings = itemsDialog.bookings.reduce((acc, booking) => {
    const date = booking?.reservation_date?.split("T")[0];
    if (!acc[date]) acc[date] = [];
    acc[date].push(booking);
    return acc;
  }, {});

  console.log("Grouped Bookings:", groupedBookings);

  // Format date like: 24 July 2025 - Monday
  const formatDateWithDay = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      weekday: "long",
    });
  };

  // Format time like: 03:45 AM
  const formatTime = (time) => {
    if (!time) return "-";
    const [h, m] = time.split(":");
    const date = new Date();
    date.setHours(h, m);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const [isSwapTableModalOpen, setIsSwapTableModalOpen] = useState(false);
  const [swapBookingId, setSwapBookingId] = useState("")
  const closeSwapTableModal = () => {
    setIsSwapTableModalOpen(false);
  };

  const [bookingItemForEdit, setBookingItemForEdit] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [isMiniModalOpen, setIsMiniModalOpen] = useState(false);
  const [floorNameForBookingForm, setFloorNameForBookingForm] = useState(null)
  const handleClose = () => {
    setIsMiniModalOpen(!isMiniModalOpen);
  };
  const handleMenuOpen = (e, booking) => {
    const rect = e.currentTarget.getBoundingClientRect();

    setMenuPosition({
      top: rect.bottom + 4,
      left: rect.left - 100,
    });
    setIsMiniModalOpen(true);
    setBookingItemForEdit(booking);
  };

  // const [hasFetched, setHasFetched] = useState(false);
  
  useEffect(() => {
    if (
      // !hasFetched &&
      // isAddNewBookingTableModalOpen &&
      // (formType === "update" || formType === "view") &&
      bookingItemForEdit &&
      !bookingItemForEdit?.customer?.number
    ) {
      dispatch(fetchAndReplaceBooking(bookingItemForEdit?.id));
      // setHasFetched(true);
    }
  }, [bookingItemForEdit]);

  if (!isOpen) return null;


  console.log("itemsDialog", itemsDialog);

  function takeOrder(bookingData) {
    console.log("Take Order Clicked", bookingData);
    dispatch(setSelectedCustomer(bookingData.customer));
    dispatch(setBookingToRedux(bookingData));
    dispatch(updateOrderType("Table"));
    onClose();
    navigate('/take-order');
  }


  function getOrderDetails(orderId) {
    setOrderDetailsId(orderId);
    dispatch(setIsLoading(true));
    getSingleOrderApi(orderId).then((res) => { 
        if (res?.data) {
            dispatch(setOrderData(res.data));
        }
        dispatch(setIsLoading(false));
    }).catch(() => {
        dispatch(setIsLoading(false));
    });
  }


  function onClose() {
    dispatch(resetSelectedLiveTable());
  }

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-20">
        <Card className="bg-cblack4 text-cwhite w-[600px] max-h-[90vh] overflow-y-scroll">
          <CardHeader className="flex flex-row justify-between items-center">
            <CardTitle className="text-cwhite text-sm font-medium">
              {itemsDialog.name} {tableType === "live_table" ? "Live Table Details" : "Table Booking Details"}
            </CardTitle>

            <X onClick={onClose} className="cursor-pointer" size={16} />
          </CardHeader>
          <Separator />
          <CardContent>
            
            <div className="flex items-center justify-center">
              {
                itemsDialog?.status !== "occupied" && 
                <button onClick={()=> setQuickTable(itemsDialog)} title="Assign table quickly without booking" className=" mt-1 px-2 py-1 bg-color6 text-sm rounded-full text-color2">Quick Table</button>
              }
            </div>
            <div className="mt-2">
              {itemsDialog?.bookings?.length > 0 ? (
                Object.entries(groupedBookings).map(([date, bookings]) => (
                  <div key={date}>
                    <p className="text-xs font-normal text-center mb-4">
                      {formatDateWithDay(date)}
                    </p>
                    {bookings.map((item, i)=>{
                      const currentStatus = bookingStatuses[item.id] || item.table_status || item.status;
                      const isActive = isCurrentBooking(
                        item.reservation_date,
                        item.start_time,
                        item.end_time
                      );


                      return (
                        <div
                          key={i}
                          className={`bg-gray-800 p-2 rounded-sm shadow-lg w-full mb-4 border ${
                            currentStatus === "occupied" || isActive ? "border-[#34c759]" : "border-transparent"
                          }`}
                        >
                          <div className="flex justify-between">
                            <div className="flex">
                              <div className="text-center pr-2 border-r-2 border-white">
                                <p className="text-[14px] font-normal">{formatTime(item.start_time)}</p>
                                <p className="text-[12px] text-gray-500 font-normal">to</p>
                                <p className="text-[14px] font-normal">
                                  {formatTime(item.end_time) || "-"}
                                </p>
                              </div>

                              <div className="text-[14px] font-normal flex flex-col justify-between pl-2">
                                <p>{item?.customer?.full_name || item?.customer_full_name || item?.customer_name || ""}</p>
                                <p className="flex items-center">
                                  <User size={16} className="mr-1" />
                                  {item?.guest || 0} <Dot /> £ {item?.advance || "0.00"}
                                </p>
                              </div>
                            </div>
                            <div className="flex gap-4">
                              {(currentStatus === "occupied" || isActive) &&
                                <div className="flex items-end gap-1 text-yellow-400 text-sm">
                                  <AlarmClock size={18} />
                                  <p className="text-[18px] font-medium">{item.end_time ? getDuration(item.start_time, item.end_time) : "Running"}</p>
                                </div>
                              }

                              <div className="flex flex-col justify-between">
                                <p className="text-[11px] font-medium flex items-center justify-between">
                                  <span>ID: {item?.unique_id || item?.id}</span>
                                  <span
                                    className="cursor-pointer"
                                    onClick={(e) => {handleMenuOpen(e, item); setFloorNameForBookingForm(itemsDialog.name)}}
                                  >
                                    <EllipsisVertical />
                                  </span>
                                </p>
                                <select
                                  value={currentStatus}
                                  onChange={(e) => {handleLiveChangeStatus(itemsDialog.id, item.id,  e.target.value)}}
                                  className={`${
                                    currentStatus === "reserved"
                                      ? "bg-[#83c27e]"
                                      : currentStatus === "waiting"
                                      ? "bg-[#dfba23]"
                                      : currentStatus === "free"
                                      ? "bg-[#525355]"
                                      : currentStatus === "occupied"
                                      ? "bg-[#f95567]"
                                      : "bg-red-800"
                                  } text-white py-1 pl-2 rounded-full border-none cursor-pointer text-[12px] font-normal`}
                                >
                                  {statuses.map((statusOption, i) => (
                                    <option key={i} value={statusOption.value}>
                                      {statusOption.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          
                            <div className="flex justify-between mt-9">
                              
                              <div className="flex gap-2 font-normal text-sm">
                                {(currentStatus === "occupied" || isActive) &&
                                  <>
                                  {
                                    item?.order_id? 
                                    <button onClick={() =>{ getOrderDetails(item?.order_id || null); }} className="px-2.5 py-2 rounded-sm bg-[#ff9500]">Order Details</button>
                                    :
                                    (hasPermission("table.live_table.take_order") && (
                                      <button onClick={()=> takeOrder(item)} className="px-2.5 py-2 rounded-sm bg-[#36cc2a]">Take Order</button>
                                    ))
                                  }
                                    
                                  </>
                                }
                              </div>
                              
                              {hasPermission("table.live_table.swap_table") && !isMerged && (
                                <button className="px-2.5 py-2 rounded-sm bg-[#007aff]" onClick={()=>{setSwapBookingId(item); setIsSwapTableModalOpen(true);}}>Swap Table</button>
                              )}
                            </div>
                        </div>
                    )})}
                  </div>
                ))
              ) : (
                <div className="bg-[#2F2F2F] h-60 w-full flex items-center justify-center">
                  <p className="text-[14px] font-normal">
                    No reservations scheduled today for this table
                  </p>
                </div>
              )}
              {
                tableType === "book_table" && <button onClick={() =>{ dispatch(openAddNewBookingTableModal()); setFloorNameForBookingForm(itemsDialog.name); setBookingItemForEdit(itemsDialog) }} className="bg-[#36cc2a] py-3 w-full rounded text-xs font-medium mt-4">Book Table</button>
              }
            </div>
          </CardContent>
        </Card>
      </div>

      {/* OVERLAY (for outside click) */}
      {isMiniModalOpen && <div className="fixed inset-0 z-[999]" onClick={handleClose}></div>}
      {/* MINI MODAL */}
      {isMiniModalOpen && (
        <div
          className="fixed z-[1000] bg-[#3a3a3a] border border-gray-600 rounded shadow-lg w-36"
          style={{
            top: menuPosition.top,
            left: menuPosition.left,
          }}
        >
          <button className="w-full text-left px-4 py-2 hover:bg-gray-700" onClick={() => { setFormType("update"); setIsMiniModalOpen(false); setIsAddNewBookingFormModalOpen(true) }}>
            Edit
          </button>
          <button className="w-full text-left px-4 py-2 hover:bg-gray-700" onClick={() => { setFormType("view"); setIsMiniModalOpen(false); setIsAddNewBookingFormModalOpen(true) }}>
            View Details
          </button>
          {/* <button className="w-full text-left px-4 py-2 hover:bg-gray-700" onClick={() => { setDeleteDialog(true); }}>
            Delete
          </button> */}
        </div>
      )}

      <AddNewBookingForm
        isOpen={isAddNewBookingFormModalOpen}
        onClose={closeAddNewBookingForm}
        formType={formType}
        setFormType={setFormType}
        bookingItemForEditId={bookingItemForEdit?.id}
        floorName={floorNameForBookingForm}
      />
      <SwapTableModal 
        isOpen={isSwapTableModalOpen}
        onClose={closeSwapTableModal}
        swapBookingId={swapBookingId}
        itemsDialog={itemsDialog}
      />
      
      {/* Confirmation Dialog for status changes */}
      {pendingStatusChange && (() => {
        const booking = itemsDialog?.bookings?.find(b => b.id === pendingStatusChange.bookingId);
        const hasOrder = !!booking?.order_id;
        const message = getConfirmationMessage(pendingStatusChange.value, hasOrder);

        return (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-[1001]">
            <Card className="bg-cblack4 text-cwhite w-[480px] border border-gray-800">
              <CardHeader className="flex flex-row justify-between items-center">
                <CardTitle className="text-cwhite text-sm font-medium">
                  Confirm Status Change
                </CardTitle>
                <X onClick={handleCancelStatusChange} className="cursor-pointer" size={16} />
              </CardHeader>
              <Separator />
              <CardContent className="mt-4">
                <p className="text-cwhite3 text-sm text-center">
                  {message}
                </p>
                <div className="mt-6 flex gap-5 w-full">
                  <Button className="w-full bg-cred text-white" onClick={handleCancelStatusChange}>
                    No
                  </Button>
                  <Button className="w-full bg-cyellow" onClick={handleConfirmStatusChange}>
                    Yes
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        );
      })()}
    </>
  );
};

export default LiveBookingDetails;